import CimentoImage from "../assets/Cimento.png";
import PisosImage from "../assets/Tratamento-de-pisos.jpg";
import SelanteImage from "../assets/Selante.png";
import PinturaImage from "../assets/Pinturas.jpg";
import AsfaltoImage from "../assets/Material-asfaltico.png";
import ColaImage from "../assets/Cola.jpg";
import GrauteImage from "../assets/graute.jpg";
import ArgamassaImage from "../assets/argamassa.jpg";
import RejunteImage from "../assets/Rejuntes.jpg";
import DrywallImage from "../assets/Drywall.jpg";
import ImpermeabilizanteImage from "../assets/Impermeabilizante.jpg";


interface Category {
    name: string,
    image: any,
    altImage: string
}

export const categories: Category[] = [
    {
        name: 'APLICADOS COM CIMENTO',
        image: CimentoImage,
        altImage: 'cimento'
    },
    {
        name: 'TRATAMENTO DE PISOS INDUSTRIAIS',
        image: PisosImage,
        altImage: 'pisos'
    },
    {
        name: 'SELANTES E COLAGENS FLEXÍVEIS',
        image: SelanteImage,
        altImage: 'selantes'
    },
    {
        name: 'PINTURAS E TRATAMENTOS IMPERMEÁVEIS',
        image: PinturaImage,
        altImage: 'pintura'
    },
    {
        name: 'MATERIAIS ASFÁLTICOS PARA IMPERMEABILIZAÇÃO E PROTEÇÃO',
        image: AsfaltoImage,
altImage: 'alfalto'
    },
    {
        name: 'COLAS E FIXADORES ESTRUTURAIS',
        image: ColaImage,
        altImage: 'cola'
    },
    {
        name: 'GRAUTES E ARGAMASSAS ESTRUTURAIS',
        image: GrauteImage,
        altImage: 'grautes'
    },
    {
        name: 'ARGAMASSAS COLANTES',
        image: ArgamassaImage,
        altImage: 'argamassas'
    },
    {
        name: 'REJUNTES',
        image: RejunteImage,
        altImage: 'rejuntes'
    },
    {
        name: 'DRYWALL E FACHADAS',
        image: DrywallImage,
        altImage: 'drywall'
    },
    {
        name: 'IMPERMEABILIZANTES',
        image: ImpermeabilizanteImage,
        altImage: 'impermeabilizantes'
    }
];
